/// <reference path="../../nativewind-augmentation.d.ts" />
// Copyright (c) Ping. All rights reserved.
//
// Privacy pane. Pinned to Figma node 3542:5795 ("Security & Privacy").

import { useState } from "react";
import { Text, View } from "react-native";
import {
	getShowTypingIndicators,
	setShowTypingIndicators as persistShowTypingIndicators,
} from "../../ephemeral/typingSettings";
import { Toggle } from "../controls";
import { SettingsDivider, SettingsRow } from "../SettingsRow";

export function PrivacyPane(): JSX.Element {
	const [showReadReceipts, setShowReadReceipts] = useState(true);
	const [showTypingIndicators, setShowTypingIndicatorsState] = useState(
		() => getShowTypingIndicators(),
	);

	return (
		<View className="flex flex-col gap-4">
			<SettingsRow
				variant="hero"
				title="Security & Privacy"
				description="Decide what other people on Ping can see about you."
				testID="settings-securityPrivacy-overview"
			/>
			<SettingsRow
				title="Send read receipts"
				description="Let others know when you have read their messages."
				testID="settings-securityPrivacy-read-receipts"
			>
				<View className="flex flex-row">
					<Toggle checked={showReadReceipts} onChange={setShowReadReceipts} />
				</View>
			</SettingsRow>

			<SettingsDivider />

			<SettingsRow
				title="Show typing indicators"
				description="Reveal the three-dot indicator while you compose."
				testID="settings-securityPrivacy-typing"
			>
				<View className="flex flex-row">
					<Toggle
						checked={showTypingIndicators}
						onChange={(next) => {
							setShowTypingIndicatorsState(next);
							persistShowTypingIndicators(next);
						}}
					/>
				</View>
			</SettingsRow>

			<SettingsDivider />

			<SettingsRow
				title="Last seen"
				description="Who can see when you were last online."
				testID="settings-securityPrivacy-last-seen"
			>
				<Text className="text-[11px] leading-[15px] text-light-text-tertiary dark:text-[#6B7280]">
					Coming soon — requires server-side preference storage.
				</Text>
			</SettingsRow>
		</View>
	);
}
